import React from 'react';
import { Table, Divider } from 'antd';
import './ConjugationTable.css';
import { useDarkMode } from "src/context/DarkModeContext";

import { chunkArray } from 'src/utils/arrayHelpers';
import { ConjugationTableData } from 'src/data/models/table-models/ConjugationTableDataModel';
import { VerbConjugation } from 'src/data/models/VerbConjugationModel';

const personLabels = ['Yo', 'Tú', 'Él/Ella', 'Nosotros', 'Vosotros', 'Ellos/Ellas'];

const ConjugationTable: React.FC<{ tableData: ConjugationTableData }> = ({ tableData }) => {
  const { isDarkMode } = useDarkMode();

  // Split verbs into chunks of 3
  const chunkedVerbs = chunkArray(tableData.verbs, 3);

  const getColumnsForChunk = (chunk: VerbConjugation[]) => {
    return [
      {
        title: 'Person',
        dataIndex: 'person',
        key: 'person',
      },
      ...chunk.map((verbConjugation: VerbConjugation, verbIndex: number) => ({
        title: verbConjugation.verb,
        key: `verb-${verbIndex}`,
        render: (text: string, record: any) => <span>{record.conjugations[verbIndex]}</span>,
      })),
    ];
  };

  const getDataForChunk = (chunk: any) => {
    return personLabels.map((person, personIndex) => ({
      key: person,
      person: person,
      conjugations: chunk.map((verb: any) => verb.conjugations[personIndex]),
    }));
  };

  return (
    <div className={`conjugation-table-container ${isDarkMode ? "dark" : ""}`}>
      <h2 className="conjugation-table-title">{tableData.title}</h2>
      {chunkedVerbs.map((chunk, chunkIndex) => (
        <div key={chunkIndex} className="conjugation-table">
          <Table
            dataSource={getDataForChunk(chunk)}
            columns={getColumnsForChunk(chunk)}
            pagination={false}
            rowClassName="ant-table-row"
            className="ant-table"
          />
          {chunkIndex < chunkedVerbs.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  );
};

export default ConjugationTable;
